<template>
	<div class="pxrwwfgv-screen-video">
		<video class="pxrwwfgv-end-video" ref="video" @click="onClickVideo" />
		<div class="pxrwwfgv-end-info" :class="{'-show': ended}" v-if="!startVideo">
			<div class="pxrwwfgv-score">Elért pontszám:<br><span>{{score}} / 7</span></div>
			<div class="pxrwwfgv-desc">{{endDescription}}</div>

			<div class="pxrwwfgv-end-buttons">
				<div class="back-button button" @click="goBack" ><wwf-icon name="back" :size="18" color="#fff" /> Vissza</div>
				<div class="solve-button button" @click="showSolve = true" >Megfejtés</div>
				<div class="restart-button button" @click="restart" >Új játék</div>
			</div>
		</div>
		<div class="pxrwwfgv-solve-popup" v-if="showSolve" ref="solvePopup">
			<div class="pxrwwfgv-solve-popup-inner" :style="solveBackground">
				<div class="pxrwwfgv-solve-popup-close" @click="showSolve = false">X</div>
				<DropSpots show-solve />
			</div>
		</div>
	</div>
</template>

<script setup >
	import _ from 'lodash';
	import { onMounted, ref, computed, defineProps, watch } from 'vue';
	import { useMediaControls, onClickOutside } from '@vueuse/core';
	import {useStore} from 'vuex';

	import WwfIcon from "@/components/ui/WwfIcon.vue";
	import DropSpots from './ScreenGame/DropSpots.vue';

	const props = defineProps({
		startVideo: {
			type: Boolean,
			default: () => false,
		},
	});

	const store = useStore();

	//game result
	let score = 0;
	_.forEach(store.getters.placedInterventions, (p) => {
		if(p.intervention.correctLocations.includes(p.dropSpot.id)){
			score++;
		}
	});


	let video_key = 0;
	if(score >= 6){
		video_key = 2;
	}
	else if(score < 6 && score > 2){
		video_key = 1;
	}

	if(props.startVideo){
		video_key = 0;
	}

	const endDescriptions = {
		sikvidek: [
			'A víz még mindig elfolyik, a táj még mindig kiszárad! Próbáld meg újra!',
			'Nagy előrelépés történt, de még tudsz mit javítani! Ugorj neki még egyszer!',
			'Nagyszerű, szép munka! Sokat segítettél a természetnek és a lakosoknak!',
		],
		dombvidek: [
			'A villámárvíz és a szárazság továbbra is probléma! Tégy még egy próbát!',
			'Nagy előrelépés történt, de még tudsz mit javítani! Ugorj neki még egyszer!',
			'Nagyszerű, szép munka! Sokat segítettél a természetnek és a lakosoknak!',
		],
	};
	const endDescription = computed(() => endDescriptions[store.getters.selectedVidek][video_key]);

	//video
	const video = ref(null);
	const { playing, muted, ended } = useMediaControls(video, {
		src: store.getters.endVideos[video_key],
	});
	muted.value = true;

	onMounted(() => {
		playing.value = true;
	});

	function restart(){
		store.dispatch('setScreen', 'home');
	}
	function goBack(){
		store.dispatch('setScreen', store.getters.selectedVidek);
	}

	watch(ended, () => {
		if(ended.value && props.startVideo) store.dispatch('setScreen', store.getters.selectedVidek);
	});


	const clickCount = ref(0);
	let clickTo = null;

	function onClickVideo(){
		if(ended.value || !props.startVideo) return;

		clickCount.value++;

		if (clickCount.value === 3) {
			store.dispatch('setScreen', store.getters.selectedVidek);
			clickCount.value = 0
			clearTimeout(clickTo)
			return;
		}

		clearTimeout(clickTo)
		clickTo = setTimeout(() => {
			clickCount.value = 0
		}, 200);
	}


	const showSolve = ref(false);
	const solvePopup = ref(null);

	const solveBackgrounds = {
		sikvidek: require('@/assets/images/background_sikvidek.svg'),
		dombvidek: require('@/assets/images/background_dombvidek.svg'),
	};
	const solveBackground = computed(() => {
		return {'background-image': `url("${solveBackgrounds[store.getters.selectedVidek]}")`};
	});

	onClickOutside(solvePopup, () => {
		showSolve.value = false
	})
</script>

<style scoped>
	.pxrwwfgv-end-video {
		position: absolute;
		z-index: 1;
		width: 100%;
		height: 100%;
		object-fit: cover;
		object-position: 50% 50%;
	}
	.pxrwwfgv-end-info {
		position: absolute;
		z-index: 2;
		width: 100%;
		height: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
		gap: 25px;
		background-color: var(--color-light-blue);

		visibility: hidden;
		opacity: 0;
		transition: opacity 700ms ease-out;
	}
	.pxrwwfgv-end-info.-show {
		visibility: visible;
		opacity: 1;
	}
	.pxrwwfgv-score {
		font-family: var(--font-heading);
		letter-spacing: 1px;
		font-size: 40px;
		line-height: 1.2;
		text-transform: uppercase;
		color: var(--color-dark-blue);
		text-align: center;
	}
	.pxrwwfgv-score span {
		font-size: 60px;
	}
	.pxrwwfgv-desc {
		font-family: var(--font-heading);
		letter-spacing: 1px;
		font-size: 40px;
		line-height: 1.2;
		text-transform: uppercase;
		color: var(--color-dark-blue);
		text-align: center;
	}
	.pxrwwfgv-end-buttons {
		display: flex;
		justify-content: center;
		align-items: center;
		gap: 15px;
	}

	.pxrwwfgv-solve-popup {
		position: absolute;
		z-index: 100;
		width: 100%;
		height: 100%;
		background-color: #bce7f2;
		box-shadow: 0px 0px 60px 0px rgba(0,0,0,0.5);
		transform: scale(0.85);
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.pxrwwfgv-solve-popup-inner {
		position: relative;
		width: 100%;
		height: 100%;
	}
	.pxrwwfgv-solve-popup-close {
		width: 50px;
		height: 50px;
		cursor: pointer;
		position: absolute;
		top: -60px;
		right: -60px;
		border-radius: 100%;
		border: 4px solid var(--color-dark-blue);
		color: var(--color-dark-blue);
		display: flex;
		justify-content: center;
		align-items: center;
		text-align: center;
		line-height: 1;
		font-family: monospace;
		font-size: 38px;
		font-weight: bold;
	}
</style>